import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { createContext } from 'react';
import { getEnv } from 'utils';

const japanStripePromise = loadStripe(getEnv('STRIPE_JAPAN_API_KEY'));
const StripeJapanContext = createContext();

export function StripeJapanProvider({ children }) {
  return (
    <StripeJapanContext.Provider value={japanStripePromise}>
      <Elements stripe={japanStripePromise}>{children}</Elements>
    </StripeJapanContext.Provider>
  );
}
